import React from 'react';
import {View} from 'react-native';
import {OverlayModal} from '../../shared/OverlayModal';

import {
  Container,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalHeadline,
  ModalBody,
  ModalTitle,
  ModalText,
  ModalFooter,
  CloseIconButton,
  CloseIcon,
  LinkButtonContainer,
} from './styles';
import {Button} from '../Forms/Buttons/Button';
import {useTheme} from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import { LinkButton } from '../Forms/Buttons/LinkButton';

interface IPromoModal {
  headerColor?: string;
  headline?: string;
  title?: string;
  text: string;
  buttonText: string;
  buttonAction: () => void;
  secondaryButtonText?: string;
  secondaryButtonAction?: () => void;
  tertiaryButtonText?: string;
  tertiaryButtonAction?: () => void;
  isVisible: boolean;
  onDismiss?: () => void;
}

export function PromoModal({
  buttonAction,
  buttonText,
  headerColor,
  headline,
  text,
  title,
  isVisible,
  onDismiss,
  secondaryButtonAction,
  secondaryButtonText,
  tertiaryButtonText,
  tertiaryButtonAction,
}: IPromoModal) {
  const theme = useTheme();

  return (
    <Container>
      <OverlayModal
        isVisible={isVisible}
        onBackdropPress={onDismiss}
        onBackButtonPress={onDismiss}>
        <ModalContainer>
          <ModalContent>
            {!!onDismiss && (
              <CloseIconButton activeOpacity={1} onPress={onDismiss}>
                <CloseIcon name="x" />
              </CloseIconButton>
            )}

            {headline && (
              <ModalHeader
                style={{
                  backgroundColor: headerColor
                    ? headerColor
                    : theme.colors.primary,
                }}>
                <ModalHeadline>{headline}</ModalHeadline>
              </ModalHeader>
            )}

            <ModalBody
              style={{marginTop: !headline ? RFValue(24) : RFValue(16)}}>
             {
              title && title?.length > 0 && <ModalTitle>{title}</ModalTitle>
             }
              <ModalText>{text}</ModalText>
            </ModalBody>
            <ModalFooter>
              <Button title={buttonText} enabled onPress={buttonAction} />

                {secondaryButtonAction && secondaryButtonText && (
                    <LinkButtonContainer>
                  <View>
                  <LinkButton
                    text={secondaryButtonText}
                    enabled

                    action={secondaryButtonAction}
                  />
                  </View>
                   </LinkButtonContainer>
                )}
                {tertiaryButtonAction && tertiaryButtonText && (
                    <LinkButtonContainer>
                  <View>
                    <LinkButton
                      text={tertiaryButtonText}
                      enabled
                      action={tertiaryButtonAction}
                    />
                  </View>
                   </LinkButtonContainer>
                )}

            </ModalFooter>
          </ModalContent>
        </ModalContainer>
      </OverlayModal>
    </Container>
  );
}
